// extracted by mini-css-extract-plugin
export default {"form":"MealForm_form__J-dF5","input":"MealForm_input__ERbkT","warn":"MealForm_warn__-W95X"};